import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";

const EditVersionName = ({ show, currentVersion, onSave, onCancel }) => {
    const [version, setVersion] = useState("");

    useEffect(() => {
        setVersion(currentVersion || "");
    }, [currentVersion]);

    const handleSave = () => {
        if (version.trim()) {
            onSave(version.trim());
        }
    };

    const handleCancel = () => {
        onCancel(currentVersion);
    };

    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            centered
            className="edit-version-name-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title className="sub-header">Edit version name</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    {/* <Form.Label>Version</Form.Label> */}
                    <Form.Control
                        type="text"
                        maxLength={20}
                        value={version}
                        onChange={(e) => setVersion(e.target.value)}
                        placeholder="e.g. v1.0.1"
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <button className="border-btn" onClick={handleCancel}>
                    Cancel
                </button>
                <button
                    className="primary-btn"
                    onClick={handleSave}
                    disabled={!version.trim()}
                >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditVersionName;
